/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import chunk from "lodash/chunk";
import flatten from "lodash/flatten";
import { array, object, string } from "prop-types";
import CollectionTitle from "../../atoms/CollectionTitle";
import { DfpComponent } from "../../ads/dfp-component";
import StoryCard from "./StoryCard/index";
import { RowSeparator } from "../../atoms/RowSeparator";

import "./three-col-six-stories.m.css";

export const ThreeColumnSixStories = ({ collection, stories, extraProp = "" }) => {
  const {
    show_column_separator,
    show_row_separator,
    show_story_separator,
    show_timestamp,
    show_read_time,
    show_row_title,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  return (
    <div className="row-component" styleName="three-col-six-stories">
      {show_row_title && (
        <div styleName="collection-title-container">
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enable_sponsor_ad}
            sponsorAdDetails={sponsor_ad_details}
            sponsorAdConfig={sponsorAdConfig}
            sectionSlug={sectionSlug}
          />
        </div>
      )}
      <div styleName="stories-container">
        {stories.map((story) => (
          <StoryCard
            key={story.id}
            story={story}
            showSeparator={show_story_separator}
            showTimeStamp={show_timestamp}
            showReadTime={show_read_time}
            sectionSlug={sectionSlug}
          />
        ))}
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`${pageType}-${collection.slug}-row-bottom-ad`}
          path={show_row_ad_unit_bottom}
          size={bottomAdConfig.sizes}
          viewPortSizeMapping={bottomAdConfig.view_port_size_mapping}
        />
      )}
    </div>
  );
};

ThreeColumnSixStories.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

ThreeColumnSixStories.storyLimit = 6;
